var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"hl-badge inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium",class:[
    {
      'bg-gray-100 text-gray-800': _vm.use === 'gray',
    },
    {
      'bg-red-100 text-red-800': _vm.use === 'red',
    },
    {
      'bg-yellow-100 text-yellow-800': _vm.use === 'yellow',
    },
    {
      'bg-green-100 text-green-800': _vm.use === 'green',
    },
    {
      'bg-blue-100 text-blue-800': _vm.use === 'blue',
    },
    {
      'bg-indigo-100 text-indigo-800': _vm.use === 'indigo',
    },
    {
      'bg-purple-100 text-purple-800': _vm.use === 'purple',
    },
    {
      'bg-pink-100 text-pink-800': _vm.use === 'pink',
    } ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }